import React from "react";

import ContactOption from "./ContactOption";

import contactDetails from "../../static/information/contactDetails";

const ContactOptionsList = () => {
  return (
    <div>
      {contactDetails.map((item) => (
        <ContactOption key={item.id} item={item} />
      ))}
    </div>
  );
};

export default ContactOptionsList;
